import * as R from 'ramda';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';

import * as BrandApiClient from 'js/brand/brand_api_client';

// action types
const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS';
const FETCH_CAMPAIGN = 'FETCH_CAMPAIGN';
const FETCH_CAMPAIGN_CONTENT_PROGRESS = 'FETCH_CAMPAIGN_CONTENT_PROGRESS';
const FETCH_CAMPAIGN_CONTENTS = 'FETCH_CAMPAIGN_CONTENTS';
const FETCH_CAMPAIGN_CONTENT = 'FETCH_CAMPAIGN_CONTENT';
const FETCH_OLDEST_CAMPAIGN_CONTENT = 'FETCH_OLDEST_CAMPAIGN_CONTENT';
const FETCH_CAMPAIGN_GUIDELINES = 'FETCH_CAMPAIGN_GUIDELINES';
const CLEAR_CONTENT_REVIEW_DATA = 'CLEAR_CONTENT_REVIEW_DATA';
const APPROVE_CONTENT = 'APPROVE_CONTENT';
const REJECT_CONTENT = 'REJECT_CONTENT';
const DO_NOT_DISTRIBUTE_CONTENT = 'DO_NOT_DISTRIBUTE_CONTENT';
const GOTO_LIST_VIEW = 'GOTO_LIST_VIEW';
const BEGIN_CONTENT_APPROVAL_TRANSMITTING = 'BEGIN_CONTENT_APPROVAL_TRANSMITTING';
const END_CONTENT_APPROVAL_TRANSMITTING = 'END_CONTENT_APPROVAL_TRANSMITTING';
// action creators
export const fetchCampaigns = createAction(FETCH_CAMPAIGNS, BrandApiClient.getCampaigns);
export const fetchCampaign = createAction(FETCH_CAMPAIGN, BrandApiClient.getCampaign);
export const fetchCampaignContentProgress = createAction(
    FETCH_CAMPAIGN_CONTENT_PROGRESS,
    BrandApiClient.getCampaignContentProgress
);
export const fetchCampaignContents = createAction(
    FETCH_CAMPAIGN_CONTENTS,
    BrandApiClient.getCampaignContents
);
export const fetchCampaignContent = createAction(
    FETCH_CAMPAIGN_CONTENT,
    async (campaignSlug, contentMetadataId) => ({
        campaign_slug: campaignSlug,
        content: await BrandApiClient.getCampaignContent(campaignSlug, contentMetadataId)
    })
);
export const fetchOldestCampaignContent = createAction(
    FETCH_OLDEST_CAMPAIGN_CONTENT,
    async (campaignSlug, skipped) => ({
        campaign_slug: campaignSlug,
        content: await BrandApiClient.getOldestPendingContentForCampaign(campaignSlug, skipped)
    })
);
export const fetchCampaignGuidelines = createAction(
    FETCH_CAMPAIGN_GUIDELINES,
    BrandApiClient.getCampaignGuidelines
);
export const clearContentReviewData = createAction(CLEAR_CONTENT_REVIEW_DATA, R.always(null));
export const approveContent = createAction(APPROVE_CONTENT, BrandApiClient.approveContent);
export const rejectContent = createAction(REJECT_CONTENT, BrandApiClient.rejectContent);
export const doNotDistributeContent = createAction(
    DO_NOT_DISTRIBUTE_CONTENT,
    BrandApiClient.doNotDistributeContent
);
export const gotoListView = createAction(GOTO_LIST_VIEW, (campaignSlug) => ({campaignSlug}));
export const beginContentApprovalTransmitting = createAction(
    BEGIN_CONTENT_APPROVAL_TRANSMITTING,
    Promise.resolve()
);
export const endContentApprovalTransmitting = createAction(
    END_CONTENT_APPROVAL_TRANSMITTING,
    Promise.resolve()
);

// reducers
export default {
    [FETCH_CAMPAIGNS]: (state, action) => R.assoc('campaigns', action.payload, state),
    [FETCH_CAMPAIGN]: (state, action) => R.merge(state, action.payload),
    [FETCH_CAMPAIGN_CONTENT_PROGRESS]: (state, action) =>
        R.assoc('campaign_content_progress', action.payload, state),
    [FETCH_CAMPAIGN_CONTENTS]: (state, action) =>
        R.assoc('campaign_contents', action.payload, state),
    [FETCH_CAMPAIGN_CONTENT]: (state, action) => {
        const {campaign_slug, content} = action.payload;
        if (content.id) {
            browserHistory.push(`/brand/content_approval/${campaign_slug}/${content.id}`);
        }
        return R.assoc('campaign_content', content, state);
    },
    [FETCH_OLDEST_CAMPAIGN_CONTENT]: (state, action) => {
        const {campaign_slug, content} = action.payload;
        if (content.id) {
            browserHistory.push(`/brand/content_approval/${campaign_slug}/${content.id}`);
        }
        else if (content) {
            browserHistory.push(`/brand/content_approval/${campaign_slug}`);
        }
        return R.assoc('campaign_content', content, state);
    },
    [FETCH_CAMPAIGN_GUIDELINES]: (state, action) =>
        R.assoc('campaign_guidelines', action.payload, state),
    [CLEAR_CONTENT_REVIEW_DATA]: (state) =>
        R.omit(['campaign_content_progress', 'campaign_content', 'campaign_guidelines'], state),
    [APPROVE_CONTENT]: (state) =>
        R.pipe(
            R.dissoc('campaign_content'),
            R.over(R.lensPath(['campaign_content_progress', 'pending']), R.dec),
            R.over(R.lensPath(['campaign_content_progress', 'approved']), R.inc)
        )(state),
    [REJECT_CONTENT]: (state) =>
        R.pipe(
            R.dissoc('campaign_content'),
            R.over(R.lensPath(['campaign_content_progress', 'pending']), R.dec)
        )(state),
    [DO_NOT_DISTRIBUTE_CONTENT]: (state) =>
        R.pipe(
            R.dissoc('campaign_content'),
            R.over(R.lensPath(['campaign_content_progress', 'pending']), R.dec)
        )(state),
    [GOTO_LIST_VIEW]: (state, action) => {
        const {campaignSlug} = action.payload;
        browserHistory.push(`/brand/content_approval/${campaignSlug}/all`);
        return state;
    },
    [BEGIN_CONTENT_APPROVAL_TRANSMITTING]: R.assoc('is_content_approval_transmitting', true),
    [END_CONTENT_APPROVAL_TRANSMITTING]: R.assoc('is_content_approval_transmitting', false)
};



// WEBPACK FOOTER //
// ./brand/content_approval/ducks/campaigns.js